export default __webpack_public_path__ + "static/media/icon-hamburger.d550a648.svg";